import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ButtonGroup } from '../button-group/index.js';
import { ButtonPrimary, ButtonTertiary } from '../button/index.js';
import { formFooter } from './form.css.js';
export const FormFooter = ({ cancel, submit }) => {
    if (cancel.hidden && submit.hidden) {
        return null;
    }
    return (_jsx("footer", { className: formFooter, children: _jsxs(ButtonGroup, { children: [!cancel.hidden && (_jsx(ButtonTertiary, { color: "subtle", disabled: cancel.disabled, label: cancel.label ?? 'Cancel', onTrigger: cancel.onTrigger, testId: cancel.testId })), !submit.hidden && (_jsx(ButtonPrimary, { disabled: submit.disabled, icon: submit.icon, loading: submit.loading, label: submit.label ?? 'Submit', onTrigger: ({ event }) => {
                        event.preventDefault();
                        submit.onTrigger();
                    }, testId: submit.testId, type: "submit" }))] }) }));
};
